import { z } from 'zod';
/** Identifiant en base (`BIGINT IDENTITY`), tel qu'il circule dans les URL et le JSON. */
export const idSchema = z.number().int().positive();
/** Paramètre d'URL : arrive en texte, sort en entier. */
export const idParamSchema = z.coerce.number().int().positive();
/** Montant en centimes, nul ou positif. */
export const centsSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
/** Montant en centimes, strictement positif. */
export const positiveCentsSchema = z.number().int().positive().max(Number.MAX_SAFE_INTEGER);
/** Montant en centimes, signé : un débit bancaire est négatif. */
export const signedCentsSchema = z.number().int().min(-Number.MAX_SAFE_INTEGER).max(Number.MAX_SAFE_INTEGER);
/** Six décimales : la précision de la base (`NUMERIC(9,6)`). Plus fin serait arrondi en silence. */
const hasAtMostSixDecimals = (value) => Math.abs(value * 1_000_000 - Math.round(value * 1_000_000)) < 1e-6;
/** Taux ou part en décimal (`0,3` pour 30 %), de 0 à 100 %, avec au plus six décimales. */
export const ratioSchema = z.number().min(0).max(1).refine(hasAtMostSixDecimals, {
    message: 'Au plus six décimales',
});
/** Variation annuelle en décimal, qui peut être négative (inflation, prix du logement). */
export const signedRatioSchema = z.number().min(-0.5).max(0.5).refine(hasAtMostSixDecimals, {
    message: 'Au plus six décimales',
});
/**
 * Taux d'intérêt annuel d'un prêt, en décimal (`0,034` pour 3,4 %).
 * Plafonné à 25 % : au-delà, c'est presque sûrement un pourcentage saisi comme un décimal.
 */
export const interestRateSchema = z.number().min(0).max(0.25).refine(hasAtMostSixDecimals, {
    message: 'Au plus six décimales',
});
/** Booléen de query string : arrive en `'true'` ou `'false'`, sort en booléen, faux par défaut. */
export const booleanQuerySchema = z
    .enum(['true', 'false'])
    .default('false')
    .transform((value) => value === 'true');
/** `?includeArchived=true` : les listes n'exposent pas les éléments archivés par défaut. */
export const includeArchivedQuerySchema = z.object({ includeArchived: booleanQuerySchema });
/** Date calendaire, `AAAA-MM-JJ`. */
export const isoDateSchema = z.iso.date();
/** Horodatage avec fuseau. */
export const timestampSchema = z.iso.datetime({ offset: true });
/** Réponse d'erreur de l'API. */
export const errorResponseSchema = z.object({
    statusCode: z.number().int(),
    code: z.string(),
    error: z.string(),
    message: z.string(),
});
//# sourceMappingURL=common.js.map